import { styled, css } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';

const alertBgColor = palette.sunshine[500];
const circleSize = 10;

interface AlertProps {
  alert: string;
}

const circle = css`
  background-color: ${theme.palette.primary.main};
  height: ${circleSize * 2}px;
  width: ${circleSize}px;
  display: inline-block;
  content: '';
  position: absolute;
  transform: translateY(-50%);
  top: 50%;
`;

const leftCircle = css`
  ${circle};
  border-bottom-right-radius: ${circleSize * 2}px;
  border-top-right-radius: ${circleSize * 2}px;
  left: -1px;
`;

const rightCircle = css`
  ${circle};
  border-bottom-left-radius: ${circleSize * 2}px;
  border-top-left-radius: ${circleSize * 2}px;
  right: -1px;
`;

export const Wrapper = styled('div')<AlertProps>`
  background: ${theme.palette.white};
  border-radius: ${theme.radius?.md};
  color: ${theme.palette.primary.main};
  margin-top: 1rem;
  position: relative;
  transition: opacity 0.3s ease-in;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }

  &:before {
    ${leftCircle}
  }

  &:after {
    ${rightCircle}
  }

  ${({ alert }) =>
    alert === 'true' &&
    css`
      &:before,
      &:after {
        background: ${alertBgColor};
      }
    `}
`;

export const Header = styled('div')`
  display: flex;
  justify-content: flex-end;
  padding: 8px;
`;

export const Footer = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0px ${theme.spacing(3)} ${theme.spacing(4)};

  svg {
    flex: none;
  }

  @media (max-width: 349px) {
    flex-wrap: wrap;
  }
`;
